import { LoadingButton } from "@mui/lab";
import { Button, Checkbox, FormControlLabel, Grid, Stack } from "@mui/material";
import { CommonModal } from "components/molecules";
import moment from "moment";
import React, { useState } from "react";

const _fileId = "upload-khsx";

const ExportPPDModal = (props: { open: boolean; onClose(): void }) => {
  const { open, onClose } = props;
  const [fromDate, setFromDate] = useState<moment.Moment | null>(moment());
  const [loading, setLoading] = useState<boolean>(false);

  const [toDate, setToDate] = useState<moment.Moment | null>(moment());
  const [fileName, setFileName] = useState<string>("");

  const handleClose = () => {};

  const handleUpload = () => {
    setLoading(true);
    const request = {};

    setTimeout(() => {
      setLoading(false);
    }, 3000);
  };

  const renderFooter = () => {
    return (
      <Footer loading={loading} onClose={onClose} onConfirm={handleUpload} />
    );
  };

  return (
    <CommonModal
      title="Xuất phiếu kế hoạch sản xuất"
      open={open}
      FooterComponent={renderFooter()}
      handleClose={onClose}
    >
      <Grid
        sx={{ width: "100%" }}
        container
        xs={12}
        alignItems="center"
        rowGap={2}
      >
        <Grid container xs={12} item columnSpacing={2}>
          <Grid xs={6} item>
            <FormControlLabel
              control={<Checkbox defaultChecked />}
              label="QR thùng"
            />
            <FormControlLabel control={<Checkbox />} label="QR sản phẩm" />
          </Grid>
        </Grid>
      </Grid>
    </CommonModal>
  );
};

const Footer = (props: {
  loading: boolean;
  onConfirm(): void;
  onClose(): void;
}) => {
  const { loading, onConfirm, onClose } = props;
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>Huỷ</Button>
      <LoadingButton loading={loading} onClick={onConfirm} variant="contained">
        Xuất phiếu
      </LoadingButton>
    </Stack>
  );
};
export default ExportPPDModal;
